import { LibraryBooks } from "@material-ui/icons";
import { ApartmentsPage } from "views/buildings/Apartments/ApartmentsPage";
import { CapturesPage } from "views/buildings/Captures/CapturesPage";
import { CollectPeriodsPage } from "views/buildings/CollectPeriods/CollectPeriodsPage";
import { FacilitiesPage } from "views/buildings/Facilities/FacilitiesPage";
import { MetersPage } from "views/buildings/Meters/MetersPage";
import { ModelsPage } from "views/buildings/models/ModelsPage";
import { NotesPage } from "views/buildings/Notes/NotesPage";
import { PaymentsPage } from "views/buildings/Payments/PaymentsPage";
import { RoutesCyclesPage } from "views/buildings/RouteCycles/RouteCyclesPage";
import { RoutesPage } from "views/buildings/Routes/RoutesPage";

export const buildingsRoutes = [
  {
    collapse: true,
    name: "Edificios",
    icon: LibraryBooks,
    state: "buildingsCollapse",
    inSidebar: true,
    isProtected: true,
    rule: "BUILDINGS",
    views: [
      {
        path: "/periodos-cobro",
        name: "Periodos de Cobro",
        mini: "CP",
        component: CollectPeriodsPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/capturas-medidores",
        name: "Capturas",
        mini: "CA",
        component: CapturesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/departamentos",
        name: "Departamentos",
        mini: "DP",
        component: ApartmentsPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/inmuebles",
        name: "Inmuebles",
        mini: "IM",
        component: FacilitiesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/medidores",
        name: "Medidores",
        mini: "ME",
        component: MetersPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/modelos-medidores",
        name: "Modelos",
        mini: "MO",
        component: ModelsPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/recibos-edificios",
        name: "Recibos",
        mini: "RE",
        component: NotesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/rutas-edificios",
        name: "Rutas",
        mini: "RO",
        component: RoutesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/periodos-corte",
        name: "Periodos de Corte",
        mini: "PC",
        component: RoutesCyclesPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      },
      {
        path: "/saldos-edificios",
        name: "Saldos",
        mini: "SA",
        component: PaymentsPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "BUILDINGS",
        noTitle: true
      }
    ].sort((a, b) => (a.name < b.name ? -1 : 1))
  }
];
